<template>
  <Card class="content backup-manage-index" style="height: 100%;" ref="card_c">
    <div class="main" style="height: 100%" @contextmenu.prevent="">
      <SelectServer ref="SelectServer" v-on:selectServerComplete="selectServerComplete"></SelectServer>
      <Modal v-model="selectOsModal" title="选择操作系统">
        <RadioGroup v-model="selectedOs">
          <Radio label="linux">
            <span>Linux</span>
          </Radio>
          <Radio label="windows">
            <span>Windows</span>
          </Radio>
        </RadioGroup>
        <div slot="footer">
          <Button type="primary" @click="selectServer">确定</Button>
          <Button @click="selectOsModal = false" style="margin-left: 8px">取消</Button>
        </div>
      </Modal>
      <div style="padding:10px; margin-bottom:20px; box-shadow:6px 6px 15px rgba(0,0,0,0.3)">
        <el-tooltip class="item" effect="dark" content="切换服务器" placement="bottom">
          <el-button type="info" plain size="mini" @click="selectOsModal = true"><Icon type="iconfont icon-server" style="font-family: iconfont" size="1"></Icon> {{ currentServer ? currentServer : '选择服务器' }}</el-button>
        </el-tooltip>
        <el-tooltip class="item" effect="dark" content="同步到存储" placement="bottom" :loading="load.transmission">
          <el-button plain size="mini" @click="syncToS3(selectData[0])" :disabled="selectData.length !== 1"><Icon type="md-arrow-round-forward" /></el-button>
        </el-tooltip>
        <el-tooltip class="item" effect="dark" content="加入计划任务" placement="bottom">
          <el-button plain size="mini" @click="toCron(selectData[0])" :disabled="selectData.length !== 1"><Icon type="md-alarm" /></el-button>
        </el-tooltip>
      </div>
      <div v-show="!currentServer">
        <div style="height: 100%; text-align: center;">
          <div class="no-chart" style="line-height: 365px;">
            <Icon type="iconfont icon-server" size="180" style="color: #f1f1f1; font-family: iconfont;" />
          </div>
        </div>
      </div>
      <div v-show="currentServer" @contextmenu.prevent="divRight">
        <Form inline @submit.native.prevent>
          <FormItem class="file-handle-box">
            <Icon type="md-arrow-round-back" :disabled="path.index <= 0" :class="{'u-disabled': path.index <= 0, 'active': path.index > 0}" @click="pathBtn('prv')" size="28"/>
            <Icon type="md-arrow-round-forward" :class="{'u-disabled': path.index >= path.history.length - 1, 'active': path.index < path.history.length - 1}" @click="pathBtn('next')" size="28"/>
            <Icon type="md-arrow-round-up" :class="{'u-disabled': currentPath === rootPath, 'active': currentPath !== rootPath}" @click="pathBtn('top')" size="28"/>
            <Icon type="md-refresh" class="active" @click="pathBtn('refresh')" size="28" />
            <Icon type="md-home" class="active" @click="pathBtn('home')" size="28"/>
          </FormItem>
          <FormItem style="width:calc(100% - 170px)">
            <Select placeholder="根目录" v-model="currentPath" @on-select="pathSelect" filterable allow-create>
              <Avatar :src="folder3xPng" slot="prefix" size="small" />
              <Option v-for="(item, idx) in historyArray()" :key="`idx_${idx}`" :value="item" v-if="item">{{ item }}</Option>
            </Select>
          </FormItem>
        </Form>
        <Table
          :height="tableHeight"
          ref="server_file_table"
          class="server_file_table"
          border
          context-menu
          @on-contextmenu="rowRightClick"
          @on-row-click="oneClick"
          @on-row-dblclick="dblClick"
          @on-selection-change="handleChange"
          @on-select="selectRow"
          @on-select-cancel="selectRowCancel"
          @on-select-all="selectAll"
          @on-select-all-cancel="selectAllCancel"
          :row-class-name="rowClassName"
          :loading="load.folder"
          :data="file_table_data"
          :columns="file_table_columns">
        </Table>
        <div class="ivu-select-dropdown" id="server-file-row-rMenu" style="visibility: hidden">
          <ul class="ivu-dropdown-menu">
            <li class="ivu-dropdown-item" @click="rMenuClick('prv')"
                :class="{'u-disabled': path.index <= 0, 'active': path.index > 0}"><Icon type="md-arrow-round-back"/> 返回</li>
            <li class="ivu-dropdown-item" @click="rMenuClick('next')"
                :class="{'u-disabled': path.index >= path.history.length - 1, 'active': path.index < path.history.length - 1}"><Icon type="md-arrow-round-forward"/> 前进</li>
            <li class="ivu-dropdown-item" @click="rMenuClick('refresh')"><Icon type="md-refresh"/> 刷新</li>
            <li class="ivu-dropdown-item" @click="rMenuClick('tran')" style="color: #ff9900" :class="{'u-disabled': load.transmission, 'active': !load.transmission}" v-if="currentRClickRow">同步到存储</li>
            <!--<li class="ivu-dropdown-item" style="color: rgb(237, 64, 20);">删除</li>-->
          </ul>
        </div>
      </div>
    </div>
  </Card>
</template>

<script>
import moment from 'moment'
import folder3xPng from '@/assets/images/file-type/folder@3x.png'
import SelectServer from '@/view/ops-center/select-server'
import { getFileLists } from '@/api/troop/troop'
import { valueTranUnit } from '@/libs/tools'

let rootPath = '/'

export default {
  name: 'server-file',
  props: {
    tableHeight: {
      type: Number,
      default: 0
    }
  },
  components: {
    SelectServer
  },
  data () {
    return {
      currentPath: '',
      folder3xPng: folder3xPng,
      rootPath: rootPath,
      separator: '/',
      file_table_data: [],
      file_table_columns: [
        {
          type: 'selection',
          width: 60,
          align: 'center'
        },
        {
          title: '名称',
          key: 'Name',
          tooltip: true,
          minWidth: 150,
          render: (h, params) => {
            let fileP = h('span', params.row.Name)
            if (this.isFolderFn(params.row)) {
              fileP = h('a', {
                on: {
                  click: () => {
                    this.routerPush(params.row)
                  }
                }
              }, params.row.Name)
            }
            return h('div', [
              h('Avatar', {
                props: {
                  src: this.fileTypeIcon(params.row),
                  size: 'small'
                },
                style: {
                  marginRight: '10px'
                }
              }),
              fileP
            ])
          }
        },
        {
          title: '修改日期',
          align: 'center',
          width: 200,
          resizable: true,
          render: (h, params) => {
            if (params.row.LastModified) {
              return h('span', moment(params.row.LastModified).format('YYYY-MM-DD HH:mm:ss'))
            } else {
              return ''
            }
          }
        },
        {
          title: '类型',
          align: 'center',
          resizable: true,
          width: 100,
          render: (h, params) => {
            return h('span', params.row.Type === 'dir' ? '文件夹' : '文件')
          }
        },
        {
          title: '大小',
          key: 'Size',
          align: 'center',
          width: 120,
          resizable: true,
          render: (h, params) => {
            if (params.row.Type === 'dir') {
              return h('span', '-')
            }
            if (params.row.Size || params.row.Size === 0) {
              return h('span', valueTranUnit(params.row.Size, 2, 'B'))
            } else {
              return h('span', '-')
            }
          }
        }
      ],
      selectData: [],
      load: {
        folder: false,
        transmission: false
      },
      path: {
        index: 0,
        history: [
          {
            path: rootPath
          }
        ]
      },
      currentServer: '',
      currentServerOs: '',
      currentRClickRow: null,
      selectOsModal: false,
      selectedOs: 'linux'
    }
  },
  watch: {
    currentServer () {
      if (!this.currentServer) {
        this.file_table_data = []
      } else {
        this.pathBtn('home')
      }
    }
  },
  methods: {
    getFileList (prefix = this.currentPath, newPath = true) {
      let params = {
        hostname: this.currentServer,
        prefix: prefix
      }
      let oldPath = this.currentPath
      this.load.folder = true
      getFileLists(params).then(res => {
        this.selectData = []
        this.load.folder = false
        this.file_table_data = res.data || []
        if (newPath && prefix !== this.currentPath) {
          this.path.history.push({
            path: prefix
          })
          this.path.index += 1
        }
        this.currentPath = prefix
      }).catch(res => {
        this.currentPath = oldPath
        this.load.folder = false
        console.error(res.response)
        this.$message.error(res.response.data.error)
      })
    },
    routerPush (row) {
      let path = row.Name
      if (this.currentPath) {
        path = `${this.currentPath}${this.currentPath.endsWith(this.separator) ? '' : this.separator}${path}`
      }
      this.path.history = this.path.history.slice(0, this.path.index + 1)
      this.getFileList(path)
    },
    isFolderFn (row) {
      return row.Type === 'dir'
    },
    handleChange (selectRow) {
      this.selectData = selectRow
    },
    gridItemCheck (c, item, idx) {
      this.$refs.server_file_table.objData[idx]._isChecked = c
      this.$nextTick(function () {
        this.handleChange(this.$refs.server_file_table.getSelection())
      })
    },
    oneClick (item, idx) {
      this.file_table_data[idx]._checked = !this.file_table_data[idx]._checked
      this.gridItemCheck(this.file_table_data[idx]._checked, item, idx)
    },
    dblClick (item) {
      if (item.Type === 'dir') {
        this.routerPush(item)
      }
    },
    selectRow (selection, row) {
      for (let i in this.file_table_data) {
        if (this.file_table_data[i].Name === row.Name) {
          this.file_table_data[i]._checked = true
        }
      }
    },
    selectRowCancel (selection, row) {
      for (let i in this.file_table_data) {
        if (this.file_table_data[i].Name === row.Name) {
          this.file_table_data[i]._checked = false
        }
      }
    },
    selectAll () {
      for (let i in this.file_table_data) {
        this.file_table_data[i]._checked = true
      }
    },
    selectAllCancel () {
      for (let i in this.file_table_data) {
        this.file_table_data[i]._checked = false
      }
    },
    // 当前是否最后一步
    pathIsEnd () {
      return this.path.index >= this.path.history.length - 1
    },
    // 当前是否第一步
    pathIsStart () {
      return this.path.index <= 0
    },
    // 前进后退刷新根目录按钮操作
    pathBtn (type) {
      if (type === 'prv') {
        if (this.pathIsStart()) return
        this.path.index -= 1
        this.getFileList(this.path.history[this.path.index].path, false)
      } else if (type === 'next') {
        if (this.pathIsEnd()) return
        this.path.index += 1
        this.getFileList(this.path.history[this.path.index].path, false)
      } else if (type === 'home') {
        this.path = {
          index: 0,
          history: [
            {
              path: this.rootPath
            }
          ]
        }
        this.getFileList(this.rootPath, false)
      } else if (type === 'top') {
        let pArr = this.currentPath.split(this.separator)
        if (pArr.length === 0 || (pArr.length === 1 && pArr[0] === '')) return
        pArr.pop(1)
        this.path.index += 1
        let targetPath = pArr.join(this.separator)
        if (!targetPath) {
          targetPath = this.rootPath + targetPath
        }
        this.getFileList(targetPath, false)
      } else {
        this.getFileList(this.currentPath, false)
      }
    },
    rMenuClick (name) {
      switch (name) {
        case 'prv':
        case 'next':
        case 'refresh':
          this.pathBtn(name)
          break
        case 'tran':
          this.syncToS3(this.currentRClickRow)
          break
      }
      this.hideRMenu()
    },
    fileTypeIcon (row) {
      let _path = ''
      // 文件夹
      if (this.isFolderFn(row)) {
        _path = require('@/assets/images/file-type/folder@3x.png')
        return _path
      }
      let fileNameSplit = row['Name'].split('.')
      // 其他根据后缀类型
      let _suffix = fileNameSplit[fileNameSplit.length - 1]
      if (!_suffix) {
        _path = require('@/assets/images/file-type/file_none@3x.png')
        return _path
      }
      if (['jpg', 'jpeg', 'png', 'gif', 'bmp'].includes(_suffix)) {
        _path = require('@/assets/images/file-type/file_img@3x.png')
      } else if (['zip', 'rar', '7z'].includes(_suffix)) {
        _path = require('@/assets/images/file-type/file_zip@3x.png')
      } else if (['avi', 'mp4', 'rmvb', 'flv', 'mov', 'm2v', 'mkv'].includes(_suffix)) {
        _path = require('@/assets/images/file-type/file_video@3x.png')
      } else if (['mp3', 'wav', 'wmv', 'wma'].includes(_suffix)) {
        _path = require('@/assets/images/file-type/file_mp3@3x.png')
      } else if (['xls', 'xlsx'].includes(_suffix)) {
        _path = require('@/assets/images/file-type/file_excel@3x.png')
      } else if (['doc', 'docx'].includes(_suffix)) {
        _path = require('@/assets/images/file-type/file_pdf@3x.png')
      } else if (_suffix === 'pdf') {
        _path = require('@/assets/images/file-type/file_docx@3x.png')
      } else if (_suffix === 'ppt') {
        _path = require('@/assets/images/file-type/file_ppt@3x.png')
      } else if (_suffix === 'txt') {
        _path = require('@/assets/images/file-type/file_txt@3x.png')
      } else {
        _path = require('@/assets/images/file-type/file_none@3x.png')
      }
      return _path
    },
    selectServer () {
      this.selectOsModal = false
      this.$refs.SelectServer.openSelectServerModal({troop_status: true, os: this.selectedOs === 'windows' ? 1 : 0}, {}, '', true)
    },
    selectServerComplete (server) {
      if (Object.keys(server).length) {
        this.currentServer = Object.keys(server)[0]
        this.currentServerOs = this.selectedOs
        if (this.currentServerOs === 'windows') {
          rootPath = ''
          this.rootPath = ''
          this.separator = '\\'
        } else {
          rootPath = '/'
          this.rootPath = '/'
          this.separator = '/'
        }
      } else {
        this.currentServer = ''
      }
    },
    historyArray () {
      let h = []
      for (let i in this.path.history) {
        if (h.indexOf(this.path.history[i].path) === -1) {
          h.push(this.path.history[i].path)
        }
      }
      return h
    },
    divRight (event) {
      this.rowRightClick(null, event)
    },
    rowRightClick (row, event) {
      this.currentRClickRow = row
      this.showRMenu(event.clientX, event.clientY)
    },
    showRMenu (x, y) {
      $('#server-file-row-rMenu ul').show()
      $('#server-file-row-rMenu').css({ 'top': y - 60 + 'px', 'left': x - 250 + 'px', 'visibility': 'visible' })
      $('body').bind('mousedown', this.onBodyMouseDown)
    },
    hideRMenu () {
      this.currentRClickRow = null
      if ($('#server-file-row-rMenu')) $('#server-file-row-rMenu').css({ 'visibility': 'hidden' })
      $('body').unbind('mousedown', this.onBodyMouseDown)
    },
    onBodyMouseDown (event) {
      if (!(event.target.id === 'rMenu' || $(event.target).parents('#server-file-row-rMenu').length > 0)) {
        $('#server-file-row-rMenu').css({ 'visibility': 'hidden' })
      }
    },
    syncToS3 (row) {
      let currentPath = this.currentPath
      if (!currentPath.endsWith(this.separator)) {
        currentPath = currentPath + this.separator
      }
      let source = `${currentPath}${row.Name}`
      if (this.isFolderFn(row)) {
        source = source + this.separator
      }
      this.load.transmission = true
      this.$emit('syncServerToS3', this.currentServer, source, row.Name, this.isFolderFn(row))
    },
    toCron (row) {
      let currentPath = this.currentPath
      if (!currentPath.endsWith(this.separator)) {
        currentPath = currentPath + this.separator
      }
      let source = `${currentPath}${row.Name}`
      if (this.isFolderFn(row)) {
        source = source + this.separator
      }
      this.$emit('serverToS3Cron', this.currentServer, source, row.Name, this.isFolderFn(row))
    },
    syncOver () {
      this.load.transmission = false
    },
    pathSelect (val) {
      this.getFileList(val.value)
    },
    rowClassName (row, idx) {
      if (this.currentRClickRow && row.Name === this.currentRClickRow.Name) {
        return 'ivu-table-row-highlight'
      }
      return ''
    }
  }
}
</script>

<style lang="less">
  @import '../base.less';
  .backup-manage-index {
    font-family: "Avenir", Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    width: 100%;
    height: 100%;
    box-sizing: border-box;
  }
  .server_file_table,
  .server_file_table th,
  .server_file_table td {
    border-color: #EBEEF5;
  }
  .server_file_table .ivu-table-row {
    font-size: 14px;
  }
  .server_file_table th {
    background-color: #F9F9F9;
  }
</style>
